export const SET_BREADCRUMB_TYPE = 'SET_BREADCRUMB_TYPE';
export const ADD_BREADCRUMB_PATH = 'ADD_BREADCRUMB_PATH';
export const REMOVE_BREADCRUMB_PATHS = 'REMOVE_BREADCRUMB_PATHS';
export const RESET_BREADCRUMB = 'RESET_BREADCRUMB';
